import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Button, Snackbar } from '@mui/material';
import { deletePolicyByCache } from 'app/store/features/privacySlice';
import apiService from 'app/services/apiService';
import appService from 'app/services/appService';

const RefreshTokenPopup = ({ open, setOpen }) => {
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);

  const dispatch = useDispatch();
  const handleRefresh = async () => {
    const { data } = await apiService.refreshToken();
    appService.setCookie(data.accessToken);
    window.location.reload();
    setOpen(false);
  };

  const cancelConfirmation = () => {
    dispatch(deletePolicyByCache(withoutTemplate?.policyType));
  };

  const handleLogout = () => {
    appService.logout();
    setOpen(false);
    cancelConfirmation();
    window.location.href = '/';
  };

  const action = (
    <>
      <Button color='primary' size='small' onClick={handleRefresh}>
        Refresh
      </Button>
      <Button color='primary' size='small' onClick={handleLogout}>
        Logout
      </Button>
    </>
  );

  return (
    <>
      <Snackbar
        open={open}
        message='Your session is about to Expire please Refresh or Logout!'
        action={action}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      />
    </>
  );
};

export default RefreshTokenPopup;
